"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

require("@/hooks.ts");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _navbar = _interopRequireDefault(require("./components/navbar/navbar.vue"));

var _sidebar = _interopRequireDefault(require("./components/sidebar/sidebar.vue"));

var _breadcrumb = _interopRequireDefault(require("./components/breadcrumb/breadcrumb.vue"));

var _footer = _interopRequireDefault(require("./components/footer/footer.vue"));

var _variables = _interopRequireDefault(require("@/styles/mixins/_variables.scss"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var App = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(App, _Vue);

  var _super = _createSuper(App);

  function App() {
    var _this;

    (0, _classCallCheck2.default)(this, App);
    _this = _super.apply(this, arguments);
    _this.isShowSidebar = false;
    return _this;
  }
  /*@Watch('$isFullscreen')
  onFSChanges(newVal: boolean) {
    this.handleWindowSize();
  }*/


  (0, _createClass2.default)(App, [{
    key: "mcStyles",
    get: function get() {
      if (this.$isFullscreen) {
        return {
          // 'height': `${window.innerHeight}px`,
          'min-height': this.$mainContainerHeight + 'px',
          'margin-top': '-1px'
        };
      } else {
        return {
          'min-height': this.$mainContainerHeight + 'px',
          'margin-top': "".concat(this.topToolbarHeight, "px")
        };
      }
    }
  }, {
    key: "loading",
    get: function get() {
      return this.$loading;
    },
    set: function set(val) {
      this.$setLoading(val);
    }
  }, {
    key: "$mainContainerHeight",
    get: function get() {
      return this.$store.getters['common/mainContainerHeight'];
    },
    set: function set(newVal) {
      this.$setMainContainerHeight(newVal);
    }
  }, {
    key: "topToolbarHeight",
    get: function get() {
      return _variables.default['top-toolbar-height-no-unit'];
    }
  }, {
    key: "created",
    value: function created() {
      if (this.$isLogIn) {
        if (this.$isAdmin) {
          this.loading = false;
        } else {
          this.handleWindowSize();
        }
      } else {
        this.loading = false;
      }
    }
  }, {
    key: "handleWindowSize",
    value: function handleWindowSize() {
      this.$mainContainerHeight = window.innerHeight - _variables.default['top-toolbar-height-no-unit'] - 2;
    }
  }, {
    key: "handleSidebarChanges",
    value: function handleSidebarChanges(val) {
      this.isShowSidebar = val;
    }
  }]);
  return App;
}(_vuePropertyDecorator.Vue);

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isLogIn', {
  namespace: 'authentication'
})], App.prototype, "$isLogIn", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isAdmin', {
  namespace: 'authentication'
})], App.prototype, "$isAdmin", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isFullscreen', {
  namespace: 'common'
})], App.prototype, "$isFullscreen", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('loading', {
  namespace: 'common'
})], App.prototype, "$loading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_LOADING', {
  namespace: 'common'
})], App.prototype, "$setLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_MAIN_CONTAINER_HEIGHT', {
  namespace: 'common'
})], App.prototype, "$setMainContainerHeight", void 0);
App = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    'navbar': _navbar.default,
    'sidebar': _sidebar.default,
    'breadcrumb': _breadcrumb.default,
    'planning-footer': _footer.default
  }
})], App);
var _default = App;
exports.default = _default;